﻿<template>

    <header class="header">
        <header_menu></header_menu>
        <hero v-if="!isValidView()" title="404 (page not found)" subtitle="Whoops! You've hit a 404 (page not found). Sorry, you'll have to turn around. " :hero_image="getHeroImage()" ></hero>
        <div v-if="!isValidView()" class="flex flex-col items-center"><button type="button" class="m-10 px-10 py-2 button button-pink-book" @click="home_Click()">Return to Home Page</button></div>
    </header>

    <main v-if="isValidView()" class="main cart-page">

        <div class="cart-head">
            <div>
                <h1>Checkout</h1>
                <p class="cart-subtitle">Enter all passenger details and choose your payment option.</p>
                <p v-if="is_Internal()" class="cart-subtitle">
                    Booking ID - {{get_Booking_ID()}}
                    <button type="button" class="button button-pink-book xsmall ml-2" @click="booking_ref_Click()">Return to Booking Ref</button>
                </p>
            </div>
            <basket_header :position=3></basket_header>
        </div>

        <div class="cart-layout">
            <div class="cart-main">
                <!-- tours with their add-ons nested under them, as in the cart (no available add-ons here) -->
                <basket v-if="isAgent_Login()" :group_addons="true"></basket>
                <basket_minimal v-else></basket_minimal>
                <passengers></passengers>
                <booking_notes></booking_notes>
            </div>

            <trip_summary></trip_summary>
        </div>

    </main>

    <footer_item></footer_item>

</template>

<script lang="ts" src="./4_check_out.ts"></script>